import { updateVerificationApi } from "@/lib/update-verification/update-verification.api"
import { useMutation } from "@tanstack/react-query"

export const updateVerificationKeys = {
   all: ["updateVerification"] as const,
   reminderStatus: () => [...updateVerificationKeys.all, "verification-reminder"] as const,
}

/**
 * Checks (and consumes) the once-per-24h "verify your email" reminder window.
 * The cadence lives in raauth (the `verification_reminder` policy); this no longer
 * writes any local timestamp. Resolves `{ show }` — true means display the modal.
 */
export const useVerificationReminderCheck = () => {
   return useMutation({
      mutationFn: () => updateVerificationApi.checkVerificationReminder(),
      meta: {
         suppressGlobalToast: true,
      },
      onError: (error) => {
         console.error("❌ Failed to check verification reminder window:", error)
      },
   })
}
